/** Controller for Label component. */
export class LabelController {}
export const sdLabel: ng.IComponentOptions = {
  controller: LabelController,
  template: "<div class='c-label' ng-transclude></div>",
  transclude: true
};
